const Chlorophyll = () => {
  const filterDates = util.setWaterYearDates();

  /**
   * Utility function used to resize the sidebars after each chart render
   */
  const resizeSidebar = () => {
    const $sidebar = document.querySelector("#annual-report-nav-wrapper");
    const $leftSection = document.querySelector(
      ".annual-report-monitoring-left-section"
    );
    const body = document.body;
    const html = document.documentElement;

    const height = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );

    $sidebar.style.height = `${height + 76}px`;
    $leftSection.style.height = `${height}px`;
  };

  const StartDate = new datePicker({
    container: "#start-date",
    elementExists: true,
    onChange: () => {
      updateData();
    },
  }).setDate(filterDates[0]);

  const EndDate = new datePicker({
    container: "#end-date",
    elementExists: true,
    onChange: () => {
      updateData();
    },
  }).setDate(filterDates[1]);

  const season = new Dropdown({
    container: "#season",
    elementExists: true,
    onChange: () => {
      updateData();
    },
  }).val("annual");

  const seasonalConcentrationsReq = {
    url: "/sites/all/scripts/view/chlora_yearly_avg.php",
    table: "viewer.chlora_avg_yearly_standard_graph",
    fields: ["*"],
    date_field: "date_time",
    value_field: "rvalue",
    units_field: "unit_name",
    standard_field: "chlora_standard",
    end_year: util.getWaterYear(),
    drupal_user_switch: false,
    drupal_userid: 1,
  };

  const seasonalConcentrationsOpt = {
    container: "#seasonal-concentrations-graph-section",
    chartType: "scatter with standard line",
    categoryField: "location",
    colors: ["#23b578"],
    gridlines: true,
    xAxis: true,
    yAxis: true,
    defaultStandardValue: 18,
  };

  const ccrDrilldownReq = {
    url: "/sites/all/scripts/view/chlora_ccr_drilldown.php",
    table: "viewer.results_simple",
    fields: ["*"],
    date_field: "rdate",
    value_field: "rvalue_converted",
    units_field: "unit_name",
    start_date: StartDate.getDate(),
    end_date: EndDate.getDate(),
    season: season.val(),
    parameter: 24,
    location1: 79,
    location2: 80,
    location3: 81,
    location4: 66,
    sort: "rdate ASC, location_name ASC, parameter ASC",
    //data: data
    //standard_field: "chlora_standard",
    drupal_user_switch: false, 
    drupal_userid: 1,
  };

  const ccrDrilldownOpt = {
    container: "#chlora-ccr-drilldown-graph-section",
    chartType: "multi-dimensional scatter",
    categoryField: "location_name",
    categoryField2: "parameter",
    colors: ["#23b578", "#5C6BC0", "#DD2C00", "#F2C300"],
    gridlines: true,
    xAxis: true,
    xAxisFormat: "%m/%y",
    yAxis: true,
    tooltipDateFormat: "MMM DD, YYYY",
    legend: true,
  };

  function updateData() {
    ccrDrilldownReq.start_date = StartDate.getDate();
    ccrDrilldownReq.end_date = EndDate.getDate();
    ccrDrilldownReq.season = season.val();

    if (season.val() === "summer") {
      ccrDrilldownOpt.xAxisFormat = "%m/%d/%y";
    } else {
      ccrDrilldownOpt.xAxisFormat = "%m/%y";
    }

    const ccrDrilldown = new Chart(ccrDrilldownReq, ccrDrilldownOpt);
    setTimeout(resizeSidebar, 1000);
  }

  const seasonalConcentrations = new Chart(
    seasonalConcentrationsReq,
    seasonalConcentrationsOpt
  );
  const ccrDrilldown = new Chart(ccrDrilldownReq, ccrDrilldownOpt);
};
